<app-platform-sidenav></app-platform-sidenav>
<div class="app-wrapper" [class.navigation-open]="sidenavService.sidenavOpen()">
  <div class="app-shell-top">
    <app-platform-topnav></app-platform-topnav>
  </div>
  <div class="router-wrapper mt-2">
    <router-outlet></router-outlet>
  </div>
</div>
<app-platform-apply-with-profile-modal />
<app-platform-onboarding-modal />
